import { useNavigate } from 'react-router-dom'
import configService from '../../services/config.service'
import { yupResolver } from '@hookform/resolvers/yup'
import { TextField, Button } from '@mui/material'
import { Controller, useForm } from 'react-hook-form'
import * as Yup from 'yup'

function SetWhitelist() {
  const navigate = useNavigate()
  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .matches(/^[a-zA-Z0-9]+$/, 'Input can only contain alphabets and digits')
      .required('Code is required'),
  })

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
    defaultValues: {
      code: '',
    },
  })

  const onSubmit = async (data) => {
    try {
      await configService.setWhitelist(data.code)
      return navigate('/')
    } catch (err) {
      return navigate('/')
    }
  }

  return (
    <div style={{ marginLeft: '10px' }}>
      <form onSubmit={handleSubmit(onSubmit)} noValidate>
        <Controller
          control={control}
          name="code"
          defaultValue=""
          render={({ field }) => (
            <TextField
              {...field}
              margin="normal"
              inputProps={{
                maxLength: 20,
              }}
              id="code"
              label={'Code'}
              name="code"
              autoFocus={true}
              error={errors.code ? true : false}
              helperText={errors.code?.message}
            />
          )}
        />
        <br />
        <Button type="submit" variant="contained" color="primary">
          PROCEED
        </Button>
      </form>
    </div>
  )
}

export default SetWhitelist
